<template>
  <div class="input-container" :class="readOnly ? 'read' : 'edit'">
    <div class="input-component">
      <sub-field-list-input-container :readOnly="readOnly" :showUnits="showUnits" :fieldConfig="fieldConfig" @change="onFieldChange" :showTooltip="showTooltip"></sub-field-list-input-container>
    </div>
  </div>
</template>

<script>
// import SegmentInputContainer from './SegmentInputContainer'
import SubFieldListInputContainer from './SubFieldListInputContainer'

export default {
  name: 'InputContainer',
  components: {SubFieldListInputContainer},
  props: {
    fieldConfig: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    showUnits: {
      type: Boolean,
      default: false
    }
  },
  model:{
    prop: 'fieldConfig',
    event: 'change'
  },
  data (){
    return {
      }
  },
  mounted () {
  },
  computed: {
    isSegmentInput(){
      return this.fieldConfig.view.inputType === 'bullseye_segment_group'
      // return Array.isArray(this.fieldConfig.value) && this.fieldConfig.value[0] && this.fieldConfig.value[0].view && this.fieldConfig.value[0].view.inputType==='segmentSelect'
    }
  },
  methods:{
    onFieldChange(){
      //WARNING:!!!
      //Parece que daba por el culo y NO SERVIA DE NADA (?) porque se modifican "sus" hijos y ya se detecta por arriba...
      // this.$emit('change',JSON.parse(JSON.stringify(this.fieldConfig)))
    }
  },
  watch:{

  }
}
</script>

<style lang="stylus" scoped>
.input-container
  display: flex
  width: 100%
  margin-bottom 20px

  .input-component
    flex: 1 1 0%

    label
      color: #515662
      m-font-size(13, 14)
      text-transform: uppercase
</style>